import { AppEnvironment } from '@models/app-info.model';

// PLEASE NOT THIS FILE IS USED ONLY LOCALLY BY ANGULAR.JSON
export const environment: AppEnvironment = AppEnvironment.local;
